import React from "react";
import { Container } from "react-grid-system";

// STYLES
import styled from "styled-components";

// SHARED
import { Section } from "../../shared/shared";

export default class Privacy extends React.PureComponent {
  render() {
    return (
      <Section>
        <Container>
          <WorksContent>
            <ColLeft>
              <WorksTitle>
                POLÍTICA DE PRIVACIDADE E DE PROTEÇÃO DE DADOS PESSOAIS
              </WorksTitle>
              <WorksText>
                <b>1. INTRODUÇÃO</b>
              </WorksText>
              <WorksText>
                A AHRESP – Associação da Hotelaria, Restauração e Similares de
                Portugal, de ora em diante apenas designada por AHRESP, respeita
                a privacidade das empresas que se inscrevem no Programa TASTE
                Portugal, através do site www.tasteportugal.com, e compromete-se
                a proteger os dados pessoais referentes às mesmas, desde logo
                nas ações subordinadas à gestão dos seus processos internos, bem
                como nas ações de comunicação e de partilha de informação que as
                mesmas decidam autorizar.
              </WorksText>
              <WorksText>
                A AHRESP, sendo uma associação de pessoas coletivas – agentes
                económicos no setor do Turismo – está a implementar o Programa
                TASTE Portugal, pelo que tem necessidade de recolher, armazenar
                e processar, dados relativos às empresas que se inscrevem no
                Programa, os quais são fundamentais para a implementação desta
                iniciativa, organizando-os em bases de dados.
              </WorksText>
              <WorksText>
                Fá-lo no sentido de poder implementar convenientemente o
                Programa e os objetivos a que se comprometeu, sendo que as
                empresas que se inscrevem, fazem-no livremente com o fim de se
                tornarem membros da Rede de Restaurantes Portugueses no Mundo.
                Ao fazê-lo, a AHRESP informa e solicita a estas empresas o
                prévio consentimento para que possa recolher e utilizar dados
                para as suas ações específicas, incluindo os relativos aos
                contactos a estabelecer com pessoas que representam essas mesmas
                entidades.
              </WorksText>
              <WorksText>
                Por outro lado, importa sublinhar que a recolha, armazenamento e
                processamento de dados pessoais relativos às empresas que se
                inscrevem no Programa (Titulares de Dados) é feita no estrito
                cumprimento da legislação aplicável sobre proteção de dados
                pessoais – Lei 67/98 de 26 de outubro (Lei da Proteção de Dados
                Pessoais) e do Regulamento EU 2016/679 do Parlamento Europeu e
                do Conselho de 27 de abril de 2016 – de forma a assegurar a
                confidencialidade e segurança dos dados fornecidos.
              </WorksText>
              <WorksText>
                A verificação de que os estabelecimentos candidatos cumprem os
                critérios necessários para pertencerem à Rede de Restaurantes
                Portugueses no Mundo efetua-se através do preenchimento online
                de um questionário.
              </WorksText>
              <WorksText>
                Este documento explica quais são os dados pessoais recolhidos
                através das interações com as empresas, como esses dados são
                utilizados e os meios de proteção associados. Sobre a atividade
                da AHRESP poderá ser consultada informação detalhada em
                <a
                  href="https://ahresp.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.AHRESP.com
                </a>
                .
              </WorksText>

              <WorksText>
                <b>2. ACERCA DOS DADOS RECOLHIDOS</b>
              </WorksText>

              <WorksText>
                Os dados recolhidos pela AHRESP referem-se, no essencial, a
                informações sobre as empresas e a sua atividade. Inserindo-se a
                recolha, armazenamento e processamento de dados, no âmbito das
                atividades das respetivas entidades, e atendendo à natureza
                empresarial subjacente, sublinha-se que os mesmos se relacionam
                com o facto de se estar perante pessoas coletivas de direito
                privado, não estando, assim, numa grande maioria, no âmbito
                específico do RGPD.
              </WorksText>

              <WorksText>
                <ul>
                  <li>Tipo de dados recolhidos</li>
                  <ul>
                    <li>De natureza geral </li>
                  </ul>
                  No contexto da ação relacionada com a gestão administrativa
                  das empresas que se inscrevem no Programa TASTE Portugal, os
                  dados recolhidos prendem-se com a necessidade de registar
                  informação sobre as mesmas, designadamente em termos da sua
                  designação comercial, incluindo morada, informação sobre o seu
                  sítio na Internet, bem como contactos telefónicos, de email ou
                  outros, e ainda demais elementos identificativos enquanto
                  pessoa coletiva. Estes dados são livremente fornecidos pelas
                  empresas no momento da sua inscrição, através do preenchimento
                  do “Boletim de Inscrição”, sendo este passível de ser
                  realizado inteiramente online através do site
                  www.tasteportugal.com.
                  <ul>
                    <li>De natureza pessoal e de contacto</li>
                  </ul>
                  No âmbito da ação administrativa da AHRESP, em termos dos
                  processos relacionados com a gestão das empresas que se
                  inscrevem no Programa TASTE Portugal, os dados pessoais
                  recolhidos prendem-se com a necessidade de obter informação
                  fundamental para a implementação do Programa, designadamente
                  da pessoa a contactar, em cada situação. Inscrevem-se neste
                  âmbito informações relacionadas com o nome e naturalidade do
                  responsável ou proprietário da empresa, bem como acerca dos
                  seus contactos telefónicos, de email ou outros.
                  <ul>
                    <li>Sobre a navegação em plataformas digitais</li>
                  </ul>
                  A AHRESP usa cookies associados às suas plataformas digitais
                  visando garantir a melhor experiência de utilização por parte
                  de cada utilizador. Monitoriza igualmente a navegação e
                  presença nas suas redes sociais. Os dados recolhidos, para
                  além de melhorarem a experiência de utilização de cada
                  utilizador, destinam-se igualmente a potenciar a melhor oferta
                  de serviços, seja esta realizada pela AHRESP, pela AHRESP
                  Serviços e/ou por entidades terceiras. 3 Em todas as
                  plataformas existe informação adicional sobre as
                  especificidades dos cookies associados aos mesmos, devendo
                  cada utilizador confirmar a sua concordância prévia sobre a
                  sua utilização durante a sua permanência e regresso a cada
                  plataforma.
                </ul>
              </WorksText>
              <WorksText>
                <ul>
                  <li>Como são recolhidos os dados</li>A informação recolhida é
                  fornecida pelos próprios e por iniciativa destes aquando do
                  processo de inscrição no Programa TASTE Portugal. Os dados são
                  obtidos através do preenchimento de formulário online, no
                  momento em que os interessados manifestam em fazer parte desta
                  iniciativa.
                  <ul>
                    <li>Qual a finalidade dos dados recolhidos</li>
                  </ul>
                  Os dados recolhidos pela AHRESP têm como finalidade assegurar
                  a existência de informação útil sobre cada uma das empresas
                  que se inscreve no Programa TASTE Portugal. Neste sentido, a
                  AHRESP entende que se inclui no âmbito de interesse destas
                  empresas a realização de ações de contacto, no sentido de as
                  informar sobre os procedimentos de adesão ao Programa, bem
                  como de ações a realizar pelas entidades contratadas pela
                  AHRESP para apoio na implementação do TASTE Portugal.
                  Entende-se assim que o contacto por possíveis entidades
                  contratadas pela AHRESP, insere-se nesse mesmo contexto,
                  podendo esta ser feita diretamente por essas entidades.
                  <br></br>
                  Como forma de aprofundamento da atividade desenvolvida pelas
                  empresas aderentes ao TASTE Portugal, a AHRESP efetua e
                  participa na realização de estudos / análises da realidade
                  económica e social existente, numa perspetiva de produção e de
                  partilha de conhecimento. Nessas ações nunca é divulgado
                  qualquer dado que permita identificar a(s) empresa(s), sendo
                  em qualquer situação preservada a privacidade do(s) mesmo(s),
                  salvo sob prévia autorização dos mesmos.
                </ul>
              </WorksText>
              <WorksText>
                <b>3. PARTILHA DOS DADOS RECOLHIDOS</b>
              </WorksText>
              <WorksText>
                A utilização dos dados recolhidos é efetuada no exclusivo
                interesse das empresas que se inscrevem no Programa TASTE
                Portugal e do setor representado pela AHRESP, podendo serem
                partilhados alguns elementos informativos. Sobre esta
                possibilidade é dado prévio conhecimento a estas empresas, as
                quais devem previamente autorizar a respetiva partilha, apesar
                da maioria dos dados partilhados não se inscreverem no âmbito do
                RGPD. Os dados pessoais eventualmente partilháveis referem-se
                exclusivamente a elementos informativos sobre as pessoas de
                contacto e/ou com responsabilidades nas empresas.
              </WorksText>

              <WorksText>
                <b>4. MECANISMOS DE PROTEÇÃO DOS DADOS RECOLHIDOS</b>
              </WorksText>
              <WorksText>
                A AHRESP assegura a necessária privacidade dos dados das
                empresas que se inscrevem no Programa TASTE Portugal, prevenindo
                a utilização indevida dos mesmos para outros fins que não os
                visados e por outras pessoas que não as autorizadas,
                designadamente em termos internos
              </WorksText>

              <WorksText>
                <ul>
                  <li>De que modo está assegurada a proteção dos dados</li>A
                  proteção de dados das empresas que se inscrevem no Programa
                  TASTE Portugal é assegurada a diferentes níveis:
                  <ul>
                    <li>Ao nível dos processos de trabalho</li>
                  </ul>
                </ul>
              </WorksText>
              <WorksText>
                A AHRESP salvaguarda o acesso exclusivo a determinados dados, de
                acordo com a natureza e a finalidade dos dados recolhidos, em
                função dos objetivos inerentes à sua utilização. Assim, para
                efeitos de contacto com as empresas que se inscrevem no Programa
                TASTE Portugal, apenas acedem a esses dados os colaboradores da
                AHRESP que tenham de contactar os mesmos, para o que recorrem
                aos meios e sistemas de informação existentes, e os
                colaboradores das entidades contratadas pela AHRESP para apoio
                na implementação do Programa, a saber:
                <ul>
                  <li>
                    IDTOUR – Unique Solutions, Lda., pessoa coletiva n.º
                    508463130, com sede no Campus Universitário de Santiago,
                    Edifício 1, 3810-193 Aveiro
                  </li>
                  <li>
                    COMER DEVAGAR, consultoria gastronómica, Lda., pessoa
                    coletiva n.º 514175451, com sede na Rua Cardoso Avelino,
                    136, 2º Esq. Trás, 5100-125 Lamego
                  </li>
                  <li>
                    Ubiwhere, Lda., pessoa coletiva n.º 508.245.567, com sede na
                    Travessa do Senhor das Barrocas, 38, 3800-075 Aveiro
                  </li>
                  <li>
                    EUROPEIA ID – Associação para a Investigação em Design,
                    Marketing e Comunicação pessoa coletiva n.º 506076547, com
                    sede na Rua Manuel Pinto de Azevedo 748, 4100- 320 Porto
                  </li>
                  <li>
                    WY CREATIVE, Marketing and Technology Services, S.A., SA,
                    pessoa coletiva n.º 505242850, com sede na Avenida Marginal,
                    Edifício Parque Oceano, 4º H, 2780-322 Oeiras
                  </li>
                </ul>
              </WorksText>
              <WorksText>
                <ul>
                  <ul>
                    <li>
                      Ao nível das tecnologias e sistemas de informação
                      existentes
                    </li>
                    A AHRESP salvaguarda que as tecnologias e sistemas de
                    informação que tem ao seu dispor garantem a proteção de
                    dados das empresas que se inscrevem no Programa TASTE
                    Portugal, em particular através da obrigatoriedade das
                    entidades contratadas pela AHRESP para apoio na
                    implementação do Programa (designadas atrás) cumprirem com
                    as especificações do RGPD, desde logo incluindo a
                    possibilidade de pseudonimização e de cifragem dos dados, a
                    5 confidencialidade, integridade, resistência e o adequado
                    funcionamento desses sistemas, bem como o restabelecimento e
                    acessibilidade aos dados em tempo adequado, em função de
                    incidentes físicos ou técnicos e ainda a adoção de
                    procedimentos de monitorização regular que garantam a
                    segurança no seu tratamento. A AHRESP exige o cumprimento do
                    RGPD por parte dos seus fornecedores de tecnologias de
                    informação, bem como de entidades terceiras, através de
                    estabelecimento de compromisso entre as partes, imputando as
                    responsabilidades associadas a cada um dos subscritores. A
                    AHRESP garante ainda que não existem réplicas de Bases de
                    Dados noutras tecnologias e/ou suportes de armazenamento,
                    salvaguardando a existência, com acesso reservado, a partes
                    das Bases de Dados originais, limitando-se estas a
                    viabilizarem o acesso interno a informação parcelar para
                    efeitos de análise e/ou suporte a atividades específicas.
                  </ul>
                </ul>
              </WorksText>
              <WorksText>
                <ul>
                  <ul>
                    <li>Limitações de acesso</li>
                  </ul>
                </ul>
              </WorksText>
              <WorksText>
                Está limitado o acesso, através de perfis de utilizadores
                especificamente criados para o efeito, com acesso condicionado
                por via de password, aos diversos colaboradores afetos às
                atividades específicas no âmbito de cada uma das tecnologias.
                Nesse sentido, existem perfis tipo, como seja:
              </WorksText>
              <WorksText>
                <ul>
                  <li>
                    <u>Administração da plataforma</u> – configura um nível de
                    utilização completo, sendo-lhe possível consultar e
                    modificar toda a informação existente. Fase ao nível de
                    acesso, este perfil tem a responsabilidade de configurar
                    outros perfis para utilizadores com acesso mais restrito, o
                    que deverá fazer em articulação com o responsável pelos
                    Sistemas e Tecnologias de Informação na AHRESP, sendo
                    igualmente o responsável pela Base de Dados perante o
                    Encarregado da Proteção de Dados (DPO – Data Proteccion
                    Officer), em termos da Privacidade e Segurança da informação
                    subjacente;
                  </li>
                  <li>
                    <u>Utilizador com permissões de criação e eliminação</u> –
                    este perfil corresponde ao do utilizador que pode aceder a
                    toda a informação sobre a Base de Dados, incluindo a criação
                    e eliminação de registos, não lhe sendo possível criar
                    utilizadores e/ou intervir ao nível da configuração da
                    aplicação. Utiliza a aplicação em todas as suas
                    funcionalidades, sendo responsável perante o Administrador
                    da plataforma em termos da fiabilidade / acuidade dos dados
                    existentes, bem como sob a reserva e proteção dos mesmos,
                    sendo-lhe vedada a partilha com outros colaboradores não
                    autorizados;
                  </li>
                  <li>
                    <u>Utilizador com permissões de consulta</u> – corresponde
                    ao perfil de utilizadores que apenas acede para consulta da
                    Base de Dados e utilização das diversas funcionalidades
                    aplicacionais. É responsável perante o Administrador da
                    plataforma sob a reserva e 6 proteção dos dados existentes,
                    sendo-lhe vetada a sua partilha com outros colaboradores não
                    autorizados;
                  </li>
                </ul>
              </WorksText>
              <WorksText>
                Para além dos perfis referidos, de utilização dos sistemas de
                informação, e nas situações em que se justifique, poderá ser
                exportada parte da informação existente em Bases de Dados, com
                vista a utilizações restritas nos diferentes domínios /
                competências da atividade da AHRESP. Essas utilizações, de
                caráter exclusivamente interno, quando existem, obrigam ao
                registo das réplicas parciais das Bases de Dados originais junto
                do responsável pela Gestão dos Sistemas e Tecnologias de
                Informação na AHRESP, o qual estabelece as formas de acesso,
                permissões e limitações, em articulação com o DPO. Essas
                utilizações estarão limitadas no tempo de utilização e formas de
                acesso, de acordo com os fins específicos que justifiquem a sua
                existência, dependendo, para este efeito, da decisão dos
                responsáveis por cada departamento o qual estabelece,
                justificadamente, essas condições. Nestas situações os
                responsáveis de departamento são quem, perante o DPO, assume
                essas responsabilidades.
              </WorksText>

              <WorksText>
                <ul>
                  <li>Durante quanto tempo se conservam os dados</li>
                </ul>
                Todos os dados pessoais são conservados pelo tempo considerado
                necessário para efeitos da manutenção da relação existente com a
                AHRESP, dentro dos prazos legais impostos ou até que a empresa
                que se inscreveu no Programa TASTE Portugal exerça o seu direito
                ao apagamento, o qual será concedido dentro dos limites legais
                aplicáveis.
              </WorksText>

              <WorksText>
                <b>5. ACESSO E DIREITO AOS DADOS</b>
              </WorksText>

              <WorksText>
                O Titular de Dados tem direito a poder aceder aos seus dados e
                sobre os mesmos solicitar alterações, entre outros direitos que
                a seguir se descriminam.
              </WorksText>

              <WorksText>
                <ul>
                  <li>Acesso, retificação, cancelamento e oposição</li>
                </ul>
              </WorksText>
              <WorksText>
                A AHRESP garante o livre acesso à informação existente sobre
                cada Titular de Dados, independentemente da plataforma digital
                subjacente, podendo o mesmo solicitar que a mesma seja
                retificada e/ou cancelada, nos termos referidos em 6., se
                designadamente a considerar desapropriada para os fins visados,
                podendo o mesmo ainda estabelecer oposição às práticas de gestão
                de dados em vigor, designadamente por via judicial, conforme
                referido em 8.
              </WorksText>

              <WorksText>
                <ul>
                  <li>Portabilidade dos dados</li>
                </ul>
              </WorksText>
              <WorksText>
                O Titular de Dados pode solicitar, nos termos referidos em 6.,
                que lhe sejam entregues os mesmos num formato estruturado, de
                uso corrente e de leitura automática, bem como solicitar a sua 7
                portabilidade, podendo requerer que esta seja realizada por
                meios informáticos, desde que disponíveis para o efeito.
              </WorksText>

              <WorksText>
                <ul>
                  <li>Direito ao esquecimento</li>
                </ul>
              </WorksText>
              <WorksText>
                O Titular de Dados pode solicitar que sejam apagados os seus
                dados, nos termos referidos em 6. Excetuam-se desta
                possibilidade, as situações por razões de exercício da liberdade
                de expressão e de informação, cumprimento de obrigações legais,
                exercício de funções de interesse público ou por autoridade
                pública, para fins de arquivo de interesse público, de
                investigação científica ou histórica ou para fins estatísticos
                em determinadas situações, ou ainda para efeitos de declaração,
                exercício ou defesa de um direito num processo judicial.
              </WorksText>

              <WorksText>
                <b>6. Encarregado da Proteção de Dados</b>
              </WorksText>

              <WorksText>
                Fica indicado como Encarregado da Proteção de Dados da AHRESP,
                José Miguel Silva, o qual tem como missão assegurar o
                cumprimento com os requisitos do RGPD e garantir toda a
                informação junto de qualquer Titular de Dados que assim o
                solicite, assim como responder às diversas solicitações que o
                mesmo possa apresentar.
              </WorksText>

              <WorksText>
                <b>
                  7. Atualização e contactos acerca da Política de Privacidade e
                  de Proteção de Dados
                </b>
              </WorksText>

              <WorksText>
                A AHRESP reserva-se o direito de atualizar a sua Política de
                Privacidade e de Proteção de Dados Pessoais em qualquer momento
                que considere necessário fazê-lo, sem que para isso seja
                necessário informar os seus associados. Qualquer associado
                poderá solicitar informação sobre a Política de Privacidade e de
                Proteção de Dados da AHRESP, junto do Encarregado da Proteção de
                Dados, através dos contactos:{" "}
                <a href="mailto:rgpd@ahresp.com">rgpd@ahresp.com</a>; 213527060
              </WorksText>

              <WorksText>
                <b>8. Lei e Foro</b>
              </WorksText>

              <WorksText>
                As presentes condições gerais regem-se pela Lei Portuguesa.
                Todos os litígios emergentes da interpretação ou execução do
                presente acordo serão dirimidos pelo Tribunal da Comarca de
                Lisboa, com expressa renúncia a qualquer outro.
              </WorksText>
            </ColLeft>
          </WorksContent>
        </Container>
      </Section>
    );
  }
}

const WorksContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ColLeft = styled.div``;

const WorksTitle = styled.h2`
  margin-top: 0;
  text-transform: uppercase;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 30px;
  line-height: 42px;
  text-align: left;
`;
const WorksText = styled.p`
  opacity: 0.8;
  font-size: 16px;
  line-height: 22px;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
`;



// WEBPACK FOOTER //
// ./src/components/privacyText/privacy.component.js